// Sepolia testnet · chainId 11155111
// Pinned addresses match the deployment recorded in metha-api/migration_output/
// and in the project root README.md. Update both on redeploy.

export const CHAIN_ID = 11155111;
export const CHAIN_NAME = 'Sepolia';

export const ADDRESSES = {
  EternalStorage:    '0xD81fFB850e44dd131D30E94eeD033CB9c8c546d9',
  MethaToken:        '0x0A1e366572f63bCa45A66dE4F5F1Ab5A62b3E16c',
  OpenGovernance:    '0x7BF8dd021477A44eD0F4b5eB48cB80cfb594917B',
  MethaCrowdsale:    '0x7B96b7e7670C6330b5F4f8b3F46245e4F49FF560',
  AuditingPool:      '0xD301Cff18Cec35F2c698a0fD7DFf81AF81098571',
  AuditorRegistryV2: '0xDead08DfFa69FF1bde30A72E4BD993A67c61Ee03',
} as const;

export type ContractName = keyof typeof ADDRESSES;

export const ETHERSCAN = (addr: string) =>
  `https://sepolia.etherscan.io/address/${addr}`;

export const TX_ETHERSCAN = (tx: string) =>
  `https://sepolia.etherscan.io/tx/${tx}`;
